export abstract class UserForm {
  cpf?: string;
  local?: string;
  senha?: string;
  ano?: Date;
}
